import { buildCustomOpts, getRequest, postRequest } from 'features/common'
import { SQL_API } from 'features/sql/api/urls'
import {
  ExportJobStatus,
  DataExportSource,
  ExportJobParams,
  CARTO_EXPORT_TASKS,
  ExportJobResponse,
  LayerExportJob,
  JobType,
  CARTO_LOCAL_STORAGE_USER_ID
} from '../types'
import { getLocalStorageItem, setLocalStorageItem } from 'app/api/localStorage'
import { getClient } from 'features/common/utils/clientParameter'

export async function createDatasetExportJob({
  connectionName,
  sources,
  accessToken
}: {
  connectionName: string
  sources: DataExportSource[]
  accessToken?: string
}): Promise<ExportJobResponse[]> {
  const result = await postRequest(
    `${SQL_API}/${connectionName}/export?client=${getClient()}`,
    {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      sources: sources.map(({ connectionName: _connectionName, accessToken: _accessToken, ...source }) => source)
    },
    buildCustomOpts({ accessToken })
  )
  return result.map((resultEntry) => ({
    jobId: resultEntry.jobId,
    connectionName,
    name: resultEntry.backendMetadata.sourceName
  }))
}

export async function getExportJobStatus({
  jobId,
  connectionName,
  accessToken
}: ExportJobParams): Promise<ExportJobStatus> {
  return (await getRequest(
    `${SQL_API}/${connectionName}/export/${jobId}?client=${getClient()}`,
    buildCustomOpts({ accessToken })
  )) as ExportJobStatus
}

export function storeLocalExportTasks(userId: string, jobs: LayerExportJob[]) {
  setLocalStorageItem(
    CARTO_EXPORT_TASKS,
    jobs.filter((job) => job.type !== JobType.LocalLayerDataExport)
  )
  setLocalStorageItem(CARTO_LOCAL_STORAGE_USER_ID, userId)
}

export function loadLocalExportTasks(userId: string): LayerExportJob[] {
  const storedUserId = getLocalStorageItem(CARTO_LOCAL_STORAGE_USER_ID)
  if (storedUserId && storedUserId !== userId) {
    setLocalStorageItem(CARTO_EXPORT_TASKS, [])
  }
  return getLocalStorageItem(CARTO_EXPORT_TASKS) || ([] as LayerExportJob[])
}
